<script>
    import { getContext } from 'svelte';
    import { TABS } from './Tabs.svelte';
    import { keydownWrapper } from '$lib/app/lib.js';

    let {
        id = null,
        children
    } = $props();

    const tab = { id: id };
    const { registerTab, selectTab, selectedTab } = getContext(TABS);

    registerTab(tab);
</script>

<!-- svelte-ignore a11y_no_noninteractive_tabindex, a11y_no_noninteractive_element_interactions -->
<li class="tab" tabindex=0 class:is-active={$selectedTab === tab} onclick={() => selectTab(tab)} onkeydown={keydownWrapper(()=> selectTab(tab))}>
    <!-- svelte-ignore a11y_missing_attribute -->
    <a>
	    {@render children?.()}
    </a>
</li>
